/*
  bf-header.js: Header beim Scrollen nach unten ausblenden, beim Hochscrollen oder nach 1 Sekunde Ruhe wieder einblenden
  (Mario 18.10.2026, Prinzip von Synouvelle assets/syn-header.js). Die weiche Überblendung kommt aus bf-header.css.
  Das Dawn-Skript in sections/header.liquid blendet in diesem Theme selbst nicht aus (Klasse hidden-s ohne Wirkung),
  deshalb übernimmt dieses Skript beides.
  Nie ausblenden, solange Menü, Suche, Warenkorb oder die Vollbild-Galerie offen sind.
*/
(function () {
  var RUHE = 1000; // Millisekunden ohne Scrollen, bis der Header wieder erscheint (Synouvelle: 350)

  function start() {
    var header = document.getElementById('shopify-section-header');
    if (!header || !document.querySelector('sticky-header')) return;
    var letzte = window.pageYOffset;
    var timer;

    function offen() {
      return /overflow-hidden/.test(document.body.className) ||
        document.documentElement.classList.contains('bf-lupe-offen') ||
        header.classList.contains('menu-open') ||
        !!header.querySelector('details[open]');
    }
    function zeigen() {
      header.classList.remove('shopify-section-header-hidden');
    }
    function verbergen() {
      if (!offen()) header.classList.add('shopify-section-header-hidden');
    }

    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      // Bis der Header ganz vorbei ist, bleibt er sichtbar (offsetTop taugt bei position: sticky nicht, daher Höhen addieren)
      var oben = 0;
      // nur Elemente im normalen Fluss zählen: der Warenkorb (cart-drawer) steht davor, ist fest positioniert und bildschirmhoch
      for (var el = header.previousElementSibling; el; el = el.previousElementSibling) {
        var pos = window.getComputedStyle(el).position;
        if (pos !== 'fixed' && pos !== 'absolute') oben += el.offsetHeight;
      }
      var grenze = oben + header.offsetHeight;
      if (y <= grenze) zeigen();
      else if (y > letzte + 2) verbergen();
      else if (y < letzte - 2) zeigen();
      letzte = y;
      window.clearTimeout(timer);
      timer = window.setTimeout(zeigen, RUHE);
    }, { passive: true });
  }

  // X in der Kopfleiste des Handy-Menüs (sections/header.liquid, .bf-menu-zu): schließt das Menü wie der Burger.
  // Dawn hängt an jeden button im Menü einen Untermenü-Schließer; der räumt aber Seitensperre und menu-open nicht auf,
  // deshalb hier das vollständige Schließen über closeMenuDrawer.
  document.addEventListener('click', function (e) {
    var zu = e.target.closest && e.target.closest('.bf-menu-zu');
    if (!zu) return;
    var drawer = zu.closest('header-drawer');
    var summary = drawer && drawer.querySelector('#Details-menu-drawer-container > summary');
    if (drawer && summary && typeof drawer.closeMenuDrawer === 'function') {
      e.preventDefault();
      drawer.closeMenuDrawer(e, summary);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
